export const examples = [
    'How old was Napoleon when he went to the island of Elba?',
    'What were the main events of World War II?',
    'What are the benefits of a balanced diet?',
]
